import { Link } from 'react-router-dom';

import { useRegistrationState } from '../../../state/contexts/RegistrationState';
import { BrandLogo } from '../../icons';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import NavGroup from './NavGroup/NavGroup';
import NetworkStatusBanner from './NetworkStatusBanner/NetworkStatusBanner';
import './styles.css';

function NavBar() {
  const [, dispatchRegisterState] = useRegistrationState();

  return (
    <div
      className="flex flex-column"
      style={{ gap: '0px', position: 'relative' }}
    >
      <NetworkStatusBanner />
      <div className="navbar" style={{ position: 'relative' }}>
        <div className="flex-row flex-left" style={{ width: 'fit-content' }}>
          <Link
            className="hover"
            to="/"
            onClick={() => {
              dispatchRegisterState({ type: 'reset' });
            }}
          >
            <div style={{ position: 'relative' }}>
              <BrandLogo width={'120px'} height={'36px'} />
            </div>
          </Link>
        </div>
        <div className="flex px-4"></div>

        <NavGroup />
      </div>
      <Breadcrumbs />
    </div>
  );
}

export default NavBar;
